import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <img
          src="/images/hero/hero-stadium.jpg"
          alt="Professional Football Stadium"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title">
          REPRESENTAMOS EL FUTURO DEL FÚTBOL
        </h1>
        <p className="hero-subtitle">
          Proyección internacional de talento futbolístico. Excelencia, profesionalismo y resultados.
        </p>
        <div className="hero-buttons">
          <Button onClick={scrollToContact} className="btn-primary btn-hero">
            Contactar Ahora
            <ArrowRight className="btn-icon" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;